<div class="form-row">
    <div class="form-group form-group-dialog-title">
        <mat-icon color="warn" class="mat-icon-dialog-title">error</mat-icon>
    </div>
    <div class="form-group form-group-dialog-title">
        <h1 mat-dialog-title>
            {{data.title}}
        </h1>
    </div>
</div>

<mat-divider></mat-divider>

<mat-dialog-content class="mat-typography conteudo-dialog">
    <p [innerHTML]="data.message"></p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button color="primary" [mat-dialog-close]="true">Fechar</button>
</mat-dialog-actions>